// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/access_right.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_planners_v1_resources_access_kind } from "./access_kind_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/access_right.proto.
 */
export const file_studyo_today_planners_v1_resources_access_right = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2FjY2Vzc19yaWdodC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJcCgtBY2Nlc3NSaWdodBIPCgd1c2VyX2lkGAEgASgJEjwKBGtpbmQYAiABKA4yLi5zdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzLkFjY2Vzc0tpbmRCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_planners_v1_resources_access_kind]);

/**
 * Describes the message studyo.today.planners.v1.resources.AccessRight.
 * Use `create(AccessRightSchema)` to create a new message.
 */
export const AccessRightSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_access_right, 0);

